/**
 * Neue App-Version (Service Worker übernimmt) → beim nächsten Zurückkehren in die App neu laden. Nie mitten in einer
 * Eingabe: Ist die App gerade sichtbar, wird gewartet, bis sie in den Hintergrund geht und wieder geöffnet wird
 * (iPhone-Home-Bildschirm-App, Wandtablet laufen sonst tagelang mit altem Code).
 */
export function reloadOnNewVersion(): void {
  if (!("serviceWorker" in navigator)) return;
  const hadController = Boolean(navigator.serviceWorker.controller);
  let updateReady = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    // Erstinstallation ist kein Update.
    if (!hadController) return;
    updateReady = true;
    if (document.visibilityState === "hidden") window.location.reload();
  });
  document.addEventListener("visibilitychange", () => {
    if (updateReady && document.visibilityState === "visible") window.location.reload();
  });
}
